import { ref, computed } from 'vue';
import { Apii } from '@/services/api.js';

export function useCardSearch() {
    const ApiService = new Apii();

    const debugCardQuery = ref('');
    const debugResults = ref([]);
    const debugShowDropdown = ref(false);
    const debugSearchRequestId = ref(0);
    const debugInputRef = ref(null);
    const dropdownTop = ref(0);
    const dropdownLeft = ref(0);
    const dropdownWidth = ref(0);
    const pendingCardChange = ref(null);
    const changeCard = ref(false);

    const hasSelectedCard = computed(() => {
        return !!(pendingCardChange.value && pendingCardChange.value.id);
    });

    const groupedDebugResults = computed(() => {
        if (!debugResults.value || debugResults.value.length === 0) return [];

        const groups = {};

        debugResults.value.forEach((card) => {
            const bankName = card.issuing_bank?.name || 'Other';

            if (!groups[bankName]) {
                groups[bankName] = {
                    bankName: bankName,
                    cards: [],
                };
            }

            groups[bankName].cards.push(card);
        });

        return Object.values(groups).sort((a, b) =>
            a.bankName.localeCompare(b.bankName)
        );
    });

    const setDropdownPosition = () => {
        if (!debugInputRef.value) return;
        const rect = debugInputRef.value.getBoundingClientRect();
        dropdownWidth.value = rect.width;
        dropdownTop.value = rect.bottom + 4;
        dropdownLeft.value = rect.left;
    };

    const onDebugCardFocus = () => {
        setDropdownPosition();
        if (debugCardQuery.value && debugCardQuery.value.trim().length >= 2) {
            debugShowDropdown.value = true;
        }
    };

    const onDebugCardInput = async () => {
        const q = (debugCardQuery.value || '').trim();
        if (q.length < 2) {
            debugResults.value = [];
            debugShowDropdown.value = false;
            return;
        }

        setDropdownPosition();
        const requestId = ++debugSearchRequestId.value;
        try {
            const res = await ApiService.apiCall(
                `/cards/user-search?s=${encodeURIComponent(q)}&institution_code=`,
                'get'
            );
            if (requestId !== debugSearchRequestId.value) return;
            debugResults.value = res?.data?.data || [];
            debugShowDropdown.value = true;
        } catch (e) {
            if (requestId !== debugSearchRequestId.value) return;
            debugResults.value = [];
            debugShowDropdown.value = true;
        }
    };

    const selectDebugCard = (card) => {
        pendingCardChange.value = card;
        debugCardQuery.value = '';
        debugResults.value = [];
        debugShowDropdown.value = false;
    };

    const clearDebugCardQuery = () => {
        debugCardQuery.value = '';
        debugResults.value = [];
        debugShowDropdown.value = false;
        pendingCardChange.value = null;
    };

    const cancelChangeCard = () => {
        changeCard.value = false;
        pendingCardChange.value = null;
        debugCardQuery.value = '';
    };

    return {
        debugCardQuery,
        debugResults,
        debugShowDropdown,
        debugSearchRequestId,
        debugInputRef,
        dropdownTop,
        dropdownLeft,
        dropdownWidth,
        pendingCardChange,
        changeCard,
        hasSelectedCard,
        groupedDebugResults,
        setDropdownPosition,
        onDebugCardFocus,
        onDebugCardInput,
        selectDebugCard,
        clearDebugCardQuery,
        cancelChangeCard,
    };
}
